// Ecommerce data source definition uses this as the externalKey of the Products
// binding context type, while CommerceAddToCartWrapper uses this in its
// BindingContext Atom constraint.
export const PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY = 'commerce-products-type';

// Ecommerce data source definition uses this as the externalKey of the Order Items
// binding context type.
export const ORDER_ITEMS_BINDING_CONTEXT_EXTERNAL_KEY =
  'commerce-order-items-type';
